import Vue from 'vue'
import Vuex from 'vuex'
import BusinessTripImposition from './master/BusinessTripImposition'
import Organization from './master/Organization'
import Generic from './master/Generic'
import Employee from './master/Employee'
import ApprovalType from './master/ApprovalType'
import Dialogs from './dialogs/Dialogs'
import DashBoard from './master/Dashboard'
import Action from './Action'
import Menu from './master/Menu'
import TripExpense from './master/TripExpense'

import BusinessTripRequest from './business-trip-request'
import BusinessTripRealization from './btrealization'
import Report from './master/Report'

import Worklist from './worklist'

import axios from 'axios'
import Promise from 'promise-polyfill'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    BusinessTripImposition,
    Organization,
    Generic,
    Employee,
    ApprovalType,
    Dialogs,
    Action,
    DashBoard,
    Menu,
    TripExpense,
    BusinessTripRequest,
    BusinessTripRealization,
    Report,
    Worklist
  },
  state: {
    login: {
      username: localStorage.getItem('username'),
      token: localStorage.getItem('token')
    },
    title: '',
    drawer: false,
    GLOBAL_IMAGES: 'https://app.waruna-group.co.id/global/images/',
    IMAGE_PLACEHOLDER: 'profile.png',
    paginationSize: 20,
    paginationSizes: [5, 10, 20, 50]
  },
  mutations: {
    updateToken: (state, value) => {
      localStorage.setItem('token', value)
      state.login.token = value
    },
    updateUsername: (state, value) => {
      localStorage.setItem('username', value)
      state.login.username = value
    },
    updateTitle: (state, value) => { state.title = value },
    reset: (state, value) => {
      state.login = Object.assign({
        username: null,
        token: null
      })
      state.title = ''
      state.drawer = false

      localStorage.clear()
    },
    toggleDrawer: (state, value) => {
      state.drawer = value
    },
    updatePaginationSize: (state, value) => {
      state.paginationSize = value
    }
  },
  getters: {
    isLoggedIn: (state) => state.login.token !== null,
    token: (state) => state.login.token,
    userName: (state) => state.Menu.menus === null ? '' : state.Menu.menus.name,
    authorities: (state) => state.Menu.menus === null ? [] : state.Menu.menus.authorities,
    getUserProfileImage: (state) => (profileImage) => {
      return state.GLOBAL_IMAGES + (typeof profileImage === 'undefined' || profileImage === null || profileImage === ''
        ? state.IMAGE_PLACEHOLDER : profileImage)
    },
    paginationSizes: (state) => state.paginationSizes,
    paginationSize: (state) => state.paginationSize
  },
  actions: {
    login: (context, payload) => {
      return new Promise((resolve, reject) => {
        axios.post('/login', {username: payload.username, password: payload.password, rememberme: payload.rememberme})
          .then(res => {
            if (res.headers.authorization !== undefined && res.headers.authorization !== null) {
              context.commit('updateToken', res.headers.authorization)
              context.commit('updateUsername', payload.username)
              resolve()
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    logout: (context, payload) => {
      context.dispatch('resetAll', payload)
    },
    setTitle: (context, payload) => {
      context.commit('updateTitle', payload.title)
    },
    toggleDrawer: (context, payload) => {
      context.commit('toggleDrawer', !context.state.drawer)
    },
    reset: (context, payload) => context.commit('reset'),
    resetAll: (context, payload) => {
      context.dispatch('reset', payload)
      context.dispatch('BusinessTripImposition/reset', payload)
      context.dispatch('Organization/reset', payload)
      context.dispatch('Generic/reset', payload)
      context.dispatch('Employee/reset', payload)
      context.dispatch('ApprovalType/reset', payload)
      context.dispatch('Dialogs/reset', payload)
      context.dispatch('Action/reset', payload)
      context.dispatch('Dashboard/reset', payload)
      context.dispatch('TripExpense/reset', payload)
      context.dispatch('BusinessTripRequest/reset', payload)
      context.dispatch('Menu/reset', payload)
      context.dispatch('BusinessTripRealization/reset', payload)
      context.dispatch('Report/reset', payload)
      context.dispatch('Worklist/reset', payload)
    },
    setPaginationSize: (context, payload) => {
      context.commit('updatePaginationSize', payload.size)
      // callback function after changing the pagination size
      if (payload.func !== undefined && typeof payload.func === 'function') {
        payload.func()
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js